import { toast } from '@/components/ui/sonner';

export const cleanTextForSpeech = (text: string): string => {
  return text
    .replace(/#{1,6}\s+/g, '') // Remove markdown headers
    .replace(/\*\*(.*?)\*\*/g, '$1') // Remove bold
    .replace(/\*(.*?)\*/g, '$1') // Remove italic
    .replace(/\`\`\`[\s\S]*?\`\`\`/g, '') // Remove code blocks
    .replace(/\`(.*?)\`/g, '$1') // Remove inline code
    .replace(/\[(.*?)\]\(.*?\)/g, '$1') // Replace links with just the text
    .replace(/\n\s*\n/g, '. ') // Replace multiple newlines with period and space
    .replace(/\s+/g, ' ') // Replace multiple spaces with single space
    .trim();
};

export const breakTextIntoChunks = (text: string, maxChars = 200): string[] => {
  const chunks: string[] = [];
  
  if (text.length <= maxChars) {
    chunks.push(text);
    return chunks;
  }
  
  let start = 0;
  while (start < text.length) {
    let end = Math.min(start + maxChars, text.length);
    
    // Find a good break point (sentence or paragraph)
    if (end < text.length) {
      const breakPoints = ['. ', '! ', '? ', '\n'];
      let bestBreak = end;
      
      for (const breakPoint of breakPoints) {
        const pos = text.lastIndexOf(breakPoint, end);
        if (pos > start && pos < end) {
          bestBreak = pos + breakPoint.length;
          break;
        }
      }
      end = bestBreak;
    }
    
    chunks.push(text.substring(start, end));
    start = end;
  }
  
  return chunks;
};

export const isSpeechSynthesisSupported = (): boolean => {
  return typeof window !== 'undefined' && 'speechSynthesis' in window;
};

export const setupKeepAlive = (speechSynthRef: React.MutableRefObject<SpeechSynthesis | null>, isPlaying: boolean, isPaused: boolean) => {
  if (!speechSynthRef.current) return () => {};
  
  // Fix for Chrome issue where speechSynthesis gets paused after ~15 seconds
  const keepAlive = () => {
    if (speechSynthRef.current && isPlaying && !isPaused) {
      speechSynthRef.current.pause();
      speechSynthRef.current.resume();
    }
  };
  
  // Set interval to keep speech synthesis alive in Chrome
  const keepAliveInterval = setInterval(keepAlive, 10000);
  
  return () => {
    clearInterval(keepAliveInterval);
  };
};
